<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.table.name',
	icon: 'lucide:table',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
	slots: ['actions'],
}
</script>
<script lang="ts" setup generic="T extends TableData">
import type { TableData } from '@nuxt/ui';
import type { CompositePrimaryKey } from '#layers/data-model/public';
import type { LayoutTableProps, SharedLayoutEmits, SharedLayoutProps, TableDisplayOptions } from '#layers/listing/public';
import { defineBlock } from '#layers/block-engine/public';
import RenderDisplayTemplate from '#layers/blocks/components/Render/RenderDisplayTemplate.vue';
import { useForwardedLayoutEmits } from '#layers/blocks/composables/use-forwarded-layout-emits';
import { LayoutTable } from '#layers/listing/public';

interface LayoutTableBlockProps extends SharedLayoutProps<TableDisplayOptions> {
	canSelect?: LayoutTableProps<T>['canSelect'];
	spacing?: LayoutTableProps<T>['spacing'];
}

defineProps<LayoutTableBlockProps>();

const emit = defineEmits<SharedLayoutEmits>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

const forwardedEmits = useForwardedLayoutEmits<SharedLayoutEmits>(emit);

;
</script>

<template>
	<LayoutTable
		v-bind="{ ...$props, ...forwardedEmits }"
		v-model:selection="selection"
		:render-display-template="RenderDisplayTemplate"
	/>
</template>
